module.exports = __webpack_public_path__ + "static/media/sound2.160a5cd6.mp3";